import { render, staticRenderFns } from "./IconReglementFacture.vue?vue&type=template&id=70c44ca6&scoped=true&"
import script from "./IconReglementFacture.vue?vue&type=script&lang=js&"
export * from "./IconReglementFacture.vue?vue&type=script&lang=js&"
import style0 from "./IconReglementFacture.vue?vue&type=style&index=0&id=70c44ca6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c44ca6",
  null
  
)

export default component.exports